import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import Index from "./pages/Index";
import CreateCampaign from "./pages/CreateCampaign";
import CampaignView from "./pages/CampaignView";
import EditCampaign from "./pages/EditCampaign";
import CampaignReport from "./pages/CampaignReport";
import BrowseCampaigns from "./pages/BrowseCampaigns";
import HowItWorks from "./pages/HowItWorks";
import Login from "./pages/Login";
import Register from "./pages/Register";
import NotFound from "./pages/NotFound";
import UserProfile from "./pages/UserProfile";
import UserSettings from "./pages/UserSettings";
import UserNotifications from "./pages/UserNotifications";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSettings from "./pages/AdminSettings";
import AdminActivity from "./pages/AdminActivity";
import AdminUsers from "./pages/AdminUsers";
import AdminCampaignModeration from "./pages/AdminCampaignModeration";
import AdminSystemHealth from "./pages/AdminSystemHealth";
import HelpSupport from "./pages/HelpSupport";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AuthCallback from "./pages/AuthCallback";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <BrowserRouter>
        <AuthProvider>
          <Toaster />
          <Sonner />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/help" element={<HelpSupport />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/create" element={<CreateCampaign />} />
            <Route path="/campaign/:id" element={<CampaignView />} />
            <Route path="/edit-campaign/:id" element={<EditCampaign />} />
            <Route path="/campaign/:id/report" element={<CampaignReport />} />
            <Route path="/browse" element={<BrowseCampaigns />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/settings" element={<UserSettings />} />
            <Route path="/notifications" element={<UserNotifications />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/activity" element={<AdminActivity />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route
              path="/admin/moderation"
              element={<AdminCampaignModeration />}
            />
            <Route path="/admin/health" element={<AdminSystemHealth />} />
            <Route path="/auth-callback" element={<AuthCallback />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
